import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: '1. Información que Recopilamos',
    body: 'Recopilamos información personal que nos proporcionas voluntariamente al realizar una compra, como tu nombre, dirección de correo electrónico y datos de pago. Los pagos son procesados de forma segura por proveedores externos certificados, y no almacenamos información completa de tarjetas de crédito en nuestros servidores.'
  }, {
    heading: '2. Uso de la Información',
    body: 'Utilizamos tu información para procesar tu compra, entregar el producto digital adquirido, enviarte actualizaciones relevantes sobre el protocolo y mejorar tu experiencia. Nunca venderemos, alquilaremos ni compartiremos tu información personal con terceros con fines comerciales.'
  }, {
    heading: '3. Cookies y Tecnologías Similares',
    body: 'Nuestro sitio utiliza cookies para mejorar la navegación, analizar el tráfico y personalizar el contenido. Puedes desactivar las cookies desde la configuración de tu navegador, aunque algunas funciones del sitio podrían verse afectadas.'
  }, {
    heading: '4. Seguridad de los Datos',
    body: 'Implementamos medidas técnicas y organizativas razonables para proteger tu información personal contra accesos no autorizados, pérdida o alteración. Sin embargo, ninguna transmisión por Internet es completamente segura, y no podemos garantizar seguridad absoluta.'
  }, {
    heading: '5. Tus Derechos',
    body: 'Tienes derecho a acceder, rectificar o eliminar tus datos personales en cualquier momento. Si deseas ejercer estos derechos, puedes hacerlo a través de los canales de soporte disponibles en tu recibo de compra.'
  }, {
    heading: '6. Cambios en esta Política',
    body: 'Nos reservamos el derecho de actualizar esta política de privacidad. Te notificaremos sobre cambios significativos mediante una notificación destacada en nuestro sitio web.'
  }]
};
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: '1. Naturaleza del Producto',
    body: 'Sistema Metabólico 40+ es un producto digital en formato PDF de carácter educativo e informativo. La compra otorga una licencia personal e intransferible para el uso del contenido. No está permitida la redistribución, reventa o reproducción del material sin autorización expresa.'
  }, {
    heading: '2. No Constituye Consejo Médico',
    body: 'El contenido de este protocolo es informativo y no sustituye el consejo, diagnóstico o tratamiento de un profesional de la salud calificado. Antes de implementar cualquier cambio significativo en tu alimentación, rutina de ejercicio o estilo de vida, consulta con tu médico, especialmente si padeces alguna condición de salud, estás embarazada o tomas medicamentos.'
  }, {
    heading: '3. Resultados Individuales',
    body: 'Los resultados varían de persona a persona y dependen de múltiples factores, incluyendo el seguimiento del protocolo, la genética, el estado de salud previo y el estilo de vida. No garantizamos resultados específicos en términos de pérdida de peso, energía o bienestar.'
  }, {
    heading: '4. Acceso y Entrega',
    body: 'Tras completar la compra, recibirás acceso inmediato al producto digital. El contenido se entrega de forma electrónica y permanece disponible para tu descarga. Es tu responsabilidad guardar una copia local del material.'
  }, {
    heading: '5. Política de Reembolso',
    body: 'Debido a la naturaleza digital e inmediata del producto, todas las ventas son finales. Antes de comprar, te invitamos a leer cuidadosamente la descripción del producto y asegurarte de que se ajuste a tus necesidades.'
  }, {
    heading: '6. Propiedad Intelectual',
    body: 'Todo el contenido del Sistema Metabólico 40+, incluyendo textos, gráficos, ilustraciones y diseño, está protegido por leyes de propiedad intelectual. La reproducción total o parcial sin autorización está prohibida.'
  }, {
    heading: '7. Limitación de Responsabilidad',
    body: 'En ningún caso seremos responsables por daños directos, indirectos, incidentales o consecuentes derivados del uso o la imposibilidad de uso del producto. Al adquirir el protocolo, aceptas asumir total responsabilidad por las decisiones que tomes respecto a tu salud y bienestar.'
  }, {
    heading: '8. Modificaciones',
    body: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones serán efectivas desde su publicación en el sitio.'
  }]
};
type ModalContent = typeof privacyContent | null;
export function Footer() {
  const [modalContent, setModalContent] = useState<ModalContent>(null);
  useEffect(() => {
    if (modalContent) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [modalContent]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setModalContent(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);
  return <>
      <footer className="bg-[#2D2A26] text-white py-12" data-id="element-55">
        <div className="container mx-auto px-6 lg:px-12" data-id="element-56">
          <div className="max-w-4xl mx-auto text-center" data-id="element-57">
            <p className="text-sm mb-4" data-id="element-58">
              © 2025 Código Hormonal 40+. Todos los derechos reservados.
            </p>
            <p className="text-xs text-gray-400 mb-6" data-id="element-59">
              Los resultados pueden variar de persona a persona. Este programa
              no constituye consejo médico. Consulta con tu médico antes de
              realizar cambios significativos en tu dieta o estilo de vida.
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-60">
              <button onClick={() => setModalContent(privacyContent)} className="hover:text-[#F4C9A8] transition-colors underline-offset-4 hover:underline" data-id="element-61">
                Política de Privacidad
              </button>
              <button onClick={() => setModalContent(termsContent)} className="hover:text-[#F4C9A8] transition-colors underline-offset-4 hover:underline" data-id="element-62">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {modalContent && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setModalContent(null)} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-63">
          <div className="bg-[#FAF6F1] rounded-3xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-64">
            <div className="flex items-center justify-between p-6 lg:p-8 border-b border-[#F4C9A8]/40" data-id="element-65">
              <h3 id="modal-title" className="text-2xl lg:text-3xl font-bold text-[#2D2A26]" data-id="element-66">
                {modalContent.title}
              </h3>
              <button onClick={() => setModalContent(null)} className="p-2 rounded-full hover:bg-[#F4C9A8]/30 transition-colors" aria-label="Cerrar" data-id="element-67">
                <XIcon className="w-6 h-6 text-[#2D2A26]" data-id="element-68" />
              </button>
            </div>
            <div className="overflow-y-auto px-6 lg:px-8 py-6 space-y-6" data-id="element-69">
              {modalContent.sections.map((section, i) => <div key={i} data-id="element-70">
                  <h4 className="text-lg font-bold text-[#2D2A26] mb-2" data-id="element-71">
                    {section.heading}
                  </h4>
                  <p className="text-[#2D2A26]/80 leading-relaxed text-sm lg:text-base" data-id="element-72">
                    {section.body}
                  </p>
                </div>)}
            </div>
            <div className="p-6 border-t border-[#F4C9A8]/40 flex justify-end" data-id="element-73">
              <button onClick={() => setModalContent(null)} className="bg-[#C97B5A] text-white px-6 py-2.5 rounded-xl font-semibold hover:bg-[#B36A4A] transition-colors" data-id="element-74">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}